import * as actionTypes from '../types/shipment';

const initialState = {
  listShipment: [],
  error: false,
  loading: false,
  okRequest: false,
  okConsignment: false,
  okList: false,
  loadingData: false,
  okUpdate: false,
  listShipmentReturnCause: [],
  listSZ: [],
  dataGetListSZ: {
    loading: false,
    okRequest: false
  },
  clientsList: {
    data: [],
    loading: false
  },
  containerType: {
    data: [],
    loading: false
  },
  listCheckingFIFO: [],
  nextPlants: {
    data: [],
    loading: false
  },
  itemPlantCode: '',
  dataEditSZ: {
    loading: false,
    okRequest: false
  },
  rollsPlacementTypes: {
    data: [],
    loading: false,
    okRequest: false
  },
  separationsLoading: false,
  separationsOkRequest: false,
  separationsByPieceList: [],
  separationsList: [],
  shipmentCondition: false
};

const reducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case actionTypes.GET_SHIPMENT_PLAN_CONTAINER_TYPE:
      return {
        ...state,
        containerType: {
          data: [],
          loading: true
        }
      };
    case actionTypes.GET_SHIPMENT_PLAN_CONTAINER_TYPE_SUCCESS:
      return {
        ...state,
        containerType: {
          data: payload,
          loading: false
        }
      };
    case actionTypes.GET_SHIPMENT_PLAN_CONTAINER_TYPE_FAIL:
      return {
        ...state,
        containerType: {
          ...state.containerType,
          loading: false
        }
      };

    case actionTypes.GET_SHIPMENT_CONSIGNMENT_CLIENTS_LIST:
      return {
        ...state,
        clientsList: {
          data: [],
          loading: true
        }
      };
    case actionTypes.GET_SHIPMENT_CONSIGNMENT_CLIENTS_LIST_SUCCESS:
      return {
        ...state,
        clientsList: {
          data: payload,
          loading: false
        }
      };
    case actionTypes.GET_SHIPMENT_CONSIGNMENT_CLIENTS_LIST_FAIL:
      return {
        ...state,
        clientsList: {
          ...state.clientsList,
          loading: false
        }
      };

    case actionTypes.GET_SHIPMENT_UPDATE:
      return {
        ...state,
        okUpdate: true,
        error: false
      };

    case actionTypes.GET_SHIPMENT:
      return {
        ...state,
        okRequest: false,
        loadingData: true,
        error: false,
        okUpdate: false,
        okList: false
      };

    case actionTypes.GET_SHIPMENT_SUCCESS:
      return {
        ...state,
        listShipment: payload,
        okRequest: false,
        loadingData: false,
        okList: true
      };

    case actionTypes.GET_SHIPMENT_FAIL:
      return {
        ...state,
        loadingData: false,
        okList: false
      };

    case actionTypes.GET_SHIPMENT_PLAN:
    case actionTypes.GET_SHIPMENT_PLAN_CANCEL:
    case actionTypes.GET_SHIPMENT_ACCEPT:
    case actionTypes.ADD_ITEMS_TO_REPORT_OVERDUE:
    case actionTypes.ADD_CLIENT_ARRIVAL_DATE:
      return {
        ...state,
        okRequest: false,
        error: false,
        loading: true
      };
    case actionTypes.GET_SHIPMENT_PLAN_SUCCESS:
      return {
        ...state,
        okUpdate: true,
        okRequest: true,
        loading: false
      };
    case actionTypes.GET_SHIPMENT_PLAN_CANCEL_SUCCESS:
      return {
        ...state,
        okUpdate: true,
        okRequest: true,
        loading: false
      };
    case actionTypes.GET_SHIPMENT_ACCEPT_SUCCESS:
    case actionTypes.ADD_ITEMS_TO_REPORT_OVERDUE_SUCCESS:
    case actionTypes.ADD_CLIENT_ARRIVAL_DATE_SUCCESS:
      return {
        ...state,
        okRequest: true,
        loading: false
      };
    case actionTypes.GET_SHIPMENT_PLAN_FAIL:
    case actionTypes.GET_SHIPMENT_PLAN_CANCEL_FAIL:
    case actionTypes.GET_SHIPMENT_ACCEPT_FAIL:
    case actionTypes.ADD_ITEMS_TO_REPORT_OVERDUE_FAIL:
    case actionTypes.ADD_CLIENT_ARRIVAL_DATE_FAIL:
      return {
        ...state,
        loading: false,
        error: payload
      };

    case actionTypes.GET_SHIPMENT_RETURN:
      return {
        ...state,
        okRequest: false,
        error: false,
        loading: true
      };

    case actionTypes.GET_SHIPMENT_RETURN_SUCCESS:
      return {
        ...state,
        okRequest: true,
        loading: false,
        okUpdate: true
      };

    case actionTypes.GET_SHIPMENT_RETURN_FAIL:
      return {
        ...state,
        loading: false,
        error: payload
      };

    case actionTypes.GET_SHIPMENT_RETURN_LIST_CAUSE:
      return {
        ...state,
        okRequest: false,
        error: false,
        loading: true
      };

    case actionTypes.GET_SHIPMENT_RETURN_LIST_CAUSE_SUCCESS:
      return {
        ...state,
        loading: false,
        listShipmentReturnCause: payload
      };

    case actionTypes.GET_SHIPMENT_RETURN_LIST_CAUSE_FAIL:
      return {
        ...state,
        loading: false,
        error: payload
      };

    case actionTypes.GET_SHIPMENT_REJECT:
      return {
        ...state,
        okRequest: false,
        loading: true,
        error: false
      };

    case actionTypes.GET_SHIPMENT_REJECT_SUCCESS:
      return {
        ...state,
        okRequest: true,
        loading: false
      };

    case actionTypes.GET_SHIPMENT_REJECT_FAIL:
      return {
        ...state,
        loading: false,
        error: payload
      };

    case actionTypes.GET_SHIPMENT_CHECK_FIFO:
      return {
        ...state,
        listCheckingFIFO: [],
        okRequest: false,
        loadingData: true,
        error: false,
        okUpdate: false
      };

    case actionTypes.GET_SHIPMENT_CHECK_FIFO_SUCCESS:

      return {
        ...state,
        listCheckingFIFO: payload,
        okRequest: false,
        loadingData: false
      };

    case actionTypes.GET_SHIPMENT_CHECK_FIFO_FAIL:
      return {
        ...state,
        loadingData: false,
        error: payload
      };

    case actionTypes.GET_SHIPMENT_CONSIGNMENT_ACCEPT:
      return {
        ...state,
        okRequest: false,
        okConsignment: false,
        loading: true,
        error: false
      };

    case actionTypes.GET_SHIPMENT_CONSIGNMENT_ACCEPT_SUCCESS:
      return {
        ...state,
        okRequest: true,
        okConsignment: true,
        loading: false
      };

    case actionTypes.GET_SHIPMENT_CONSIGNMENT_ACCEPT_FAIL:
      return {
        ...state,
        okRequest: false,
        okConsignment: false,
        loading: false,
        error: payload
      };

    case actionTypes.GET_SHIPMENT_ACT_REMOVE_MX3:
    case actionTypes.GET_SHIPMENT_ACT_REMOVE_M15B:
      return {
        ...state,
        loading: true,
        error: false,
        okRequest: false
      };

    case actionTypes.GET_SHIPMENT_ACT_REMOVE_MX3_SUCCESS:
    case actionTypes.GET_SHIPMENT_ACT_REMOVE_M15B_SUCCESS:
      return {
        ...state,
        loading: false,
        okRequest: true
      };

    case actionTypes.GET_SHIPMENT_ACT_REMOVE_MX3_FAIL:
    case actionTypes.GET_SHIPMENT_ACT_REMOVE_M15B_FAIL:
      return {
        ...state,
        loading: false,
        error: payload
      };

    case actionTypes.GET_SHIPMENT_ERROR_CLEAR:
      return {
        ...state,
        error: false,
        okRequest: false
      };

    case actionTypes.GET_SHIPMENT_CLEAR:
      return {
        ...state,
        okRequest: false
        // okUpdate: false
      };

    case actionTypes.GET_NEXT_PLANTS:
      return {
        ...state,
        nextPlants: {
          data: [],
          loading: true
        }
      };
    case actionTypes.GET_NEXT_PLANTS_SUCCESS:
      return {
        ...state,
        nextPlants: {
          data: payload,
          loading: false
        }
      };
    case actionTypes.GET_NEXT_PLANTS_FAIL:
      return {
        ...state,
        nextPlants: {
          ...state.nextPlants,
          loading: false
        }
      };

    case actionTypes.GET_NEXT_PLANT:
      return {
        ...state,
        itemPlantCode: '',
        loading: true
      };
    case actionTypes.GET_NEXT_PLANT_SUCCESS:
      return {
        ...state,
        itemPlantCode: payload,
        loading: false
      };
    case actionTypes.GET_NEXT_PLANT_FAIL:
      return {
        ...state,
        loading: false
      };

    case actionTypes.GET_SZ_LIST:
      return {
        ...state,
        listSZ: [],
        dataGetListSZ: {
          loading: true,
          okRequest: false
        }
      };
    case actionTypes.GET_SZ_LIST_SUCCESS:
      return {
        ...state,
        listSZ: payload,
        dataGetListSZ: {
          loading: false,
          okRequest: true
        }
      };
    case actionTypes.GET_SZ_LIST_FAIL:
    case actionTypes.GET_SZ_LIST_CLEAR:
      return {
        ...state,
        listSZ: [],
        dataGetListSZ: {
          loading: false,
          okRequest: false
        }
      };

    case actionTypes.UPDATE_SZ:
      return {
        ...state,
        dataEditSZ: {
          loading: true,
          okRequest: false
        }
      };
    case actionTypes.UPDATE_SZ_SUCCESS:
      return {
        ...state,
        dataEditSZ: {
          loading: false,
          okRequest: true
        }
      };
    case actionTypes.UPDATE_SZ_FAIL:
      return {
        ...state,
        dataEditSZ: {
          loading: false,
          okRequest: false
        }
      };

    case actionTypes.SET_INITIAL_STATE_SHIPMENT:
      return {
        ...initialState
      };
    case actionTypes.GET_ROLLS_PLACEMENT_TYPES:
      return {
        ...state,
        rollsPlacementTypes: {
          data: [],
          loading: true,
          okRequest: false
        }
      };
    case actionTypes.GET_ROLLS_PLACEMENT_TYPES_SUCCESS:
      return {
        ...state,
        rollsPlacementTypes: {
          data: payload,
          loading: false,
          okRequest: true
        }
      };
    case actionTypes.GET_ROLLS_PLACEMENT_TYPES_FAIL:
      return {
        ...state,
        rollsPlacementTypes: {
          ...state.rollsPlacementTypes,
          loading: false,
          okRequest: false
        }
      };

    case actionTypes.GET_SEPARATIONS_LIST:
      return {
        ...state,
        error: false,
        separationsLoading: true,
        separationsOkRequest: false,
        separationsList: []
      };

    case actionTypes.GET_SEPARATIONS_LIST_SUCCESS:
      return {
        ...state,
        error: false,
        separationsLoading: false,
        separationsOkRequest: true,
        separationsList: payload
      };

    case actionTypes.GET_SEPARATIONS_LIST_FAIL:
      return {
        ...state,
        error: payload,
        separationsLoading: false,
        separationsOkRequest: false,
        separationsList: []
      };

    case actionTypes.GET_SEPARATIONS_BY_PIECES:
      return {
        ...state,
        error: false,
        separationsLoading: true,
        separationsOkRequest: false,
        separationsByPieceList: []
      };

    case actionTypes.GET_SEPARATIONS_BY_PIECES_SUCCESS:
      return {
        ...state,
        error: false,
        separationsLoading: false,
        separationsOkRequest: true,
        separationsByPieceList: payload
      };

    case actionTypes.GET_SEPARATIONS_BY_PIECES_FAIL:
      return {
        ...state,
        error: payload,
        separationsLoading: false,
        separationsOkRequest: false,
        separationsByPieceList: []
      };
    default:
      return state;
  }
};

export default reducer;
